module.exports = __webpack_public_path__ + "img/jdr_item.01858f68.png";